// LIMIT-07 — read an HTTP `Retry-After` header as a wait in seconds.

/**
 * parseRetryAfter reads `Retry-After` as delta-seconds, the only form our servers
 * send. Absent, zero, negative or an HTTP-date ⇒ undefined (not known).
 */
export function parseRetryAfter(header: string | null | undefined): number | undefined {
  const trimmed = header?.trim() ?? '';
  if (!/^\d+$/.test(trimmed)) return undefined;
  const secs = Number(trimmed);
  return secs > 0 ? secs : undefined;
}
